import { Component, OnInit, Inject, Input, Output, ViewChild, SimpleChanges, EventEmitter } from '@angular/core';
import { Http } from '@angular/http';

import { NvD3Component } from 'ng2-nvd3';

declare var $: any;
declare let d3: any;

interface InputSeries {
    data: number[];
    color: string;
    title: string;
}

interface LineChartSeries {
    key: string;
    color: string;
    values: LineChartDataPoint[];
    area: boolean;
}

interface ProfileData {
    date: string;
    value: string;
}

interface LineChartDataPoint {
    x: number;
    y: number;
}

@Component({
    selector: 'line-chart',
    templateUrl: './line-chart.component.html',
    styleUrls: [
        './line-chart.component.css'
        // Inclusion here matches instructions https://github.com/krispo/ng2-nvd3, but styling of chart failed
        // As workaround included css file separately in wwwroot and _Layout.cshtml
        //,'../../../../../node_modules/nvd3/build/nv.d3.css'
    ]
})
export class LineChartComponent {
    @Input() graphTitle: string = "";
    @Input() series: Array<InputSeries> = [];
    @Input() labelData: Array<string> = [];
    @Input() area: boolean = false;
    @Input() height: number = 300;
    
    @ViewChild('nvd3') nvd3: NvD3Component | undefined;

    options: any;
    data: LineChartSeries[] = [];

    ngOnInit() {
        var labelFunction = (i: any) => this.labelData[i];

        this.options = {
            chart: {
                type: 'lineChart',
                height: this.height,
                margin: {
                    top: 5,
                    right: 20,
                    bottom: 50,
                    left: 45
                },
                useInteractiveGuideline: true,
                showLegend: true,
                showXAxis: true,
                showYAxis: true,
                noData: "Nog geen gegevens",
                xAxis: {
                    showMaxMin: false,
                    tickValues: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24],
                    rotateLabels: -45,
                    tickFormat: labelFunction
                },
                yAxis: {
                    showMaxMin: false,
                    tickFormat: function(d: any) {
                        return d3.format(',.2f')(d);
                    }
                }
            }
        };
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['series']) {
            this.data = [];
            this.initData();
        }
    }

    initData() {
        if (this.series) {
            for (var i = 0; i < this.series.length; i++) {
                // Only process data if data is there and is not already loaded
                if (this.series[i].data) {
                    this.processData(this.series[i].data, this.series[i].title, this.series[i].color);
                }
            }
        }
    }

    processData(dataAgg: number[], title: string, color: string) {
        var dataSerie = this.createChartSeries(dataAgg, title, color);

        if (this.data == undefined) {
            this.data = [dataSerie];
        } else {
            this.data.push(dataSerie);
        }
        if (this.nvd3 && this.nvd3.chart) {
            this.nvd3.chart.update();
        }
    }

    createChartSeries(data: number[], title: string, color: string): LineChartSeries {
        var seriesData: LineChartDataPoint[] = new Array<LineChartDataPoint>();        
        for (var i = 0; i < data.length; i++) {
            seriesData.push({
                "x": i,
                "y": data[i]
            });
        }

        return {
            "key": title,
            "color": color,
            "values": seriesData,
            "area": this.area
        };
    }
}



// WEBPACK FOOTER //
// ./ClientApp/app/pages/_shared/line-chart/line-chart.component.ts